var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles, Typography, useTheme } from "@material-ui/core";
import classNames from "classnames";
import React, { Fragment } from "react";
const useStyles = makeStyles((theme) => ({
    unselectable: {
        userSelect: "none"
    },
    compact: {
        lineHeight: 1.1
    },
    clickable: {
        cursor: "pointer"
    }
}));
export const Text = (props) => {
    const theme = useTheme();
    const classes = useStyles(props);
    const { className, weight, color, nowrap, style, compact, unselectable, clickable, nl2br } = props, other = __rest(props, ["className", "weight", "color", "nowrap", "style", "compact", "unselectable", "clickable", "nl2br"]);
    const textClasses = classNames(className, {
        [classes.unselectable]: unselectable,
        [classes.compact]: compact,
        [classes.clickable]: clickable
    });
    let updatedStyle = {};
    if (weight) {
        updatedStyle.fontWeight = weight;
    }
    if (nowrap) {
        updatedStyle.whiteSpace = "nowrap";
    }
    if (typeof color === "function") {
        updatedStyle.color = color(theme.palette.type);
    }
    updatedStyle = Object.assign(Object.assign({}, updatedStyle), style);
    const children = nl2br ? newLineToBr(props.children) : props.children;
    return (React.createElement(Typography, Object.assign({ className: textClasses, color: typeof color === "function" ? undefined : color, style: updatedStyle }, other), children));
};
const newLineToBr = (children) => {
    if (typeof children === "string") {
        return children.split(/\n?\\n/).map((value, key) => (React.createElement(Fragment, { key: key },
            value,
            React.createElement("br", null))));
    }
    return children;
};
//# sourceMappingURL=Text.js.map